class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    
    // const swiperNotice = swiperFun();
    // swiperNotice.init();
   // 总金额变化 进度条变化 start

    // 总金额变化 进度条变化 end
    // var cartContents = fetch(window.Shopify.routes.root + "cart.js")
    //   .then((response) => response.json())
    //   .then((data) => {
    //     console.log(123123)
    //     var cartList = data.items;
    //     var cartArr = [];
    //     if (cartList.length > 0) {
    //       cartList.forEach((item) => {
    //         var list = {
    //           product_id: item.product_id,
    //           price: item.original_line_price,
    //         };
    //         cartArr.push(list);
    //       });
    //       console.log("data", cartArr);
    //       // 请求接口拿到金额
    //     }
    //     return data;
    //   });
    // this.getTotalAmount();
    $('.quantity__input[data-quantity-variant-id=49453187989720]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=49453198573784]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=49453191659736]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=49574880084184]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=49638086082776]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=49638098370776]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=49638100893912]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=49679472918744]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=49726532550872]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=49726532583640]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=49726532616408]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=49726532649176]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=49959044939992]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=49959046578392]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=49959050707160]').prop('readonly', 'readonly').val("1").parent().hide();
    
    $('.quantity__input[data-quantity-variant-id=50370903441624]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=50370901147864]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=50370899804376]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.cart-remove-button[data-variant-id=50370903441624]').hide();
    $('.cart-remove-button[data-variant-id=50370901147864]').hide();
    $('.cart-remove-button[data-variant-id=50370899804376]').hide();
    
    //返校季
    $('.quantity__input[data-quantity-variant-id=50696109457624]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.cart-remove-button[data-variant-id=50696109457624]').hide();

      var product_id = ['8723973275864','8723973570776','8723973341400','8741184864472','8741185650904','8741185978584','8746390824920','8750606123224','8779804508376','8779805199272','8779806114008'];
      var superGiftSyp_id = ['8735241797848']
      var cartContents = fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        var cartArr = [];
        var cartList = data.items; 
        var finalTotalPrice = data.total_price / 100;
        const GIFT_A_ID = 50370903441624;  //  C$170
        const GIFT_B_ID = 50370901147864;  // C$309
        const GIFT_C_ID = 50370899804376; // C$599
        const GIFT_D_ID = 50696109457624; // C$319 返校季
        
        const Phone_Cases_ID = 41257929080965;
        const PhoneCasesIdsToCheck = [41255273889925, 41255273922693, 41257574531205,41255271366789,41255271399557,41257574563973,41255271465093,41255271497861,41257574596741,41255271563397,41255271596165,41257574629509,41255274840197,41255274872965,41255274905733];
        let PhoneCasesTotalQuantity = 0;
        let hasPhoneCase = false;
        let phoneCaseQuantity = 0;

        let hasGiftA = false;
        let hasGiftB = false;
        let hasGiftC = false;
        let hasGiftD = false;
        // 一些购物车的处理
        if(data.item_count > 0){
         $('.cart-count-amount>span:nth-child(1)').text(data.item_count)
        }else{
          $('.cart-count-amount').hide();
        }
        if(data.original_total_price){
          var originalTotalPrice = data.original_total_price / 100;
          $('s[data-cart-total]').children().text('C$'+originalTotalPrice);
        }
        $('.total_value>span').text('C$'+finalTotalPrice)
        $('#item_count').text(data.item_count+' items')
        if(finalTotalPrice == 0){
          $('.cart__checkout-button button').attr('disabled','true')
        }

        
        if (cartList.length > 0) {
          cartList.forEach((item) => {
            cartArr.push(item.product_id);
            if (item.id === GIFT_A_ID) hasGiftA = true;
            if (item.id === GIFT_B_ID) hasGiftB = true;
            if (item.id === GIFT_C_ID) hasGiftC = true;
            if (item.id === GIFT_D_ID) hasGiftD = true;
            if (PhoneCasesIdsToCheck.includes(item.id)) {
              PhoneCasesTotalQuantity += item.quantity || 0; // 安全处理undefined情况
            }
            // 检查购物车是否已包含Phone_Cases_ID
            if (item.id === Phone_Cases_ID) {
              hasPhoneCase = true;
              phoneCaseQuantity = item.quantity;
            }
          });
        }

        // 合并删除操作对象
        const delOperations = {};
        // 合并添加操作数组
        const addItems = [];
      
        //返校季活动代码
        if (finalTotalPrice < 319 && (hasGiftA || hasGiftB || hasGiftC || hasGiftD)) {
          Object.assign(delOperations, {
            [GIFT_A_ID]: 0,
            [GIFT_B_ID]: 0,
            [GIFT_C_ID]: 0,
            [GIFT_D_ID]: 0
          });
        } 
        else if (finalTotalPrice >= 319) {
          if (!hasGiftD) addItems.push({ id: GIFT_D_ID, quantity: 1 });
        }

        // 第一阶段：处理赠品逻辑
        // if (finalTotalPrice < 170  && (hasGiftA || hasGiftB || hasGiftC)) {
        //   Object.assign(delOperations, {
        //     [GIFT_A_ID]: 0,
        //     [GIFT_B_ID]: 0,
        //     [GIFT_C_ID]: 0
        //   });
        // } 
        // else if (finalTotalPrice >= 170 ) {
        //   // 条件1: 170-309区间
        //   if (finalTotalPrice < 309) {
        //     if (hasGiftB) delOperations[GIFT_B_ID] = 0;
        //     else if (hasGiftC) delOperations[GIFT_C_ID] = 0;
        //     if (!hasGiftA) addItems.push({ id: GIFT_A_ID, quantity: 1 });
        //   }
        //   // 条件2: 309-599区间
        //   else if (finalTotalPrice < 599) {
        //     if (hasGiftA) delOperations[GIFT_A_ID] = 0;
        //     else if (hasGiftC) delOperations[GIFT_C_ID] = 0;
        //     if (!hasGiftB) addItems.push({ id: GIFT_B_ID, quantity: 1 });
        //   }
        //   // 条件3: ≥599
        //   else {
        //     if (hasGiftA) delOperations[GIFT_A_ID] = 0;
        //     else if (hasGiftB) delOperations[GIFT_B_ID] = 0;
        //     if (!hasGiftC) addItems.push({ id: GIFT_C_ID, quantity: 1 });
        //   }
        // }
      
        // 第二阶段：处理手机壳数量同步
        if (PhoneCasesTotalQuantity >= 0) {
          const currentQuantity = hasPhoneCase ? phoneCaseQuantity : 0;
          if (PhoneCasesTotalQuantity > currentQuantity) {
            addItems.push({
              id: Phone_Cases_ID,
              quantity: PhoneCasesTotalQuantity - currentQuantity
            });
          }
          else if (PhoneCasesTotalQuantity !== 0 && PhoneCasesTotalQuantity < currentQuantity) {
            delOperations[Phone_Cases_ID] = currentQuantity - PhoneCasesTotalQuantity;
          }
          else if (PhoneCasesTotalQuantity === 0 && hasPhoneCase) {
            delOperations[Phone_Cases_ID] = 0;
          }
        }
      
        // 批量执行操作
        if (Object.keys(delOperations).length > 0) {
          this.clearcart(delOperations);
        }
        if (addItems.length > 0) {
          this.addCart({ items: addItems });
        }
          
        const commonElements = product_id.filter(item => cartArr.some(otherItem => otherItem == item));
        const sypElements = superGiftSyp_id.filter(item => cartArr.some(otherItem => otherItem == item));
        if(commonElements && commonElements.length > 0){
            $('.auto2-free-gift .product-form__submit').attr('disabled',true);
            $("#auto2-free-gift-tips").show();   
            $('#updates_8723973275864').hide();
            $('#updates_8723973570776').hide();
            $('#updates_8723973341400').hide();
            $('#updates_8741184864472').hide();
            $('#updates_8741185650904').hide();
            $('#updates_8741185978584').hide();
            $('#updates_8746390824920').hide();
            $('#updates_8750606123224').hide();
            $('.product div[data-id="8750606123224"] #reset_button').show().attr('disabled', true);
            $('.product div[data-id="8750606123224"] .product-form__off').show();
            $('.product div[data-id="8750606123224"] .product-form__off').text('* Already have one in your cart');
              setTimeout(function(){
                 $('#cart_recom1_8750606123224.product-form__submit,#updates_8750606123224.product-form__submit,#cart_recom1_8723973275864.product-form__submit,#cart_recom1_8723973570776.product-form__submit,#cart_recom1_8723973341400.product-form__submit,#cart_recom1_8741184864472.product-form__submit,#cart_recom1_8741185650904.product-form__submit,#cart_recom1_8741185978584.product-form__submit,#cart_recom1_8746390824920.product-form__submit,#cart_recom1_8779804508376.product-form__submit,#cart_recom1_8779805199272.product-form__submit,#cart_recom1_8779806114008.product-form__submit').attr('disabled', true);
              },1000);
        }else{
            $('.auto2-free-gift .product-form__submit').attr('disabled',false);
            $("#auto2-free-gift-tips").hide();
            $('#updates_8723973275864').show();
            $('#updates_8723973570776').show();
            $('#updates_8723973341400').show();
            $('#updates_8741184864472').show();
            $('#updates_8741185650904').show();
            $('#updates_8741185978584').show();
            $('#updates_8746390824920').show();
            $('#updates_8750606123224').show();
            $('.product div[data-id="8750606123224"] #reset_button').hide().attr('disabled', false);
            $('.product div[data-id="8750606123224"] .product-form__off').hide();
              setTimeout(function(){
                 $('#cart_recom1_8750606123224.product-form__submit,#updates_8750606123224.product-form__submit,#cart_recom1_8723973275864.product-form__submit,#cart_recom1_8723973570776.product-form__submit,#cart_recom1_8723973341400.product-form__submit,#cart_recom1_8741184864472.product-form__submit,#cart_recom1_8741185650904.product-form__submit,#cart_recom1_8741185978584.product-form__submit,#cart_recom1_8746390824920.product-form__submit,#cart_recom1_8779804508376.product-form__submit,#cart_recom1_8779805199272.product-form__submit,#cart_recom1_8779806114008.product-form__submit').attr('disabled', false);
              },1000);
        }
        
        if(sypElements && sypElements.length > 0){
           $('.auto2-dialog-addcart .product-form__submit').attr('disabled',true);
           $(".auto2-claim-now-tips").show();
        }else{
           $('.auto2-dialog-addcart .product-form__submit').attr('disabled',false);
           $(".auto2-claim-now-tips").hide();
        }
        return data;
      });
  }

  clearcart(updates) {
    $('#CartDrawer .drawer__inner').addClass('cart-drawer-loading');
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
    .then((response) => {
      return response.json();
    })
    .then(() => {
      this.onCartUpdate(); // 调用onCartUpdate方法刷新购物车抽屉式面板
      $('#CartDrawer .drawer__inner').removeClass('cart-drawer-loading');
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  }
  addCart(updates) {
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
    })
    .then(response => {
        return response.json();
    })
    .then(() => {
      this.onCartUpdate(); // 调用onCartUpdate方法刷新购物车抽屉式面板
    })
    .catch((error) => {
        console.error('Error:', error);
    });
  }
  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Drawer-quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';
    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }
    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    if(event.target.name == "note"){
      return
    }
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
        document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cartDrawer-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.querySelector('.cart_drawer_totals');
        
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cartDrawer-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        
        // 总金额变化 进度条变化 start
        /*var totalNumber = Number(parsedState.total_price) / 100;
        var progressBar = document.querySelector('.progress-bar');
        var percentage = (totalNumber / 80) * 100;
        progressBar.style.width = `${percentage}%`;*/
        // 总金额变化 进度条变化 end

      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
    
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    //console.log(html,selector)
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.querySelector('.CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.querySelector('.CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
